/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TariffCoreQuery = {
    validFrom?: string;
    validity?: TariffCoreQuery.validity;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
    /**
     * Sort by. Default: id
     */
    sortBy?: string;
    /**
     * Sort order descendent. Default: true
     */
    sortDesc?: boolean;
    /**
     * Sort with locale. Default: sk
     */
    sortLocale?: string;
    /**
     * Page Size. Default: 25
     */
    limit?: number;
    /**
     * Offsetting x items. Default: 0
     */
    offset?: number;
};
export namespace TariffCoreQuery {
    export enum validity {
        PAST = 'PAST',
        PRESENT = 'PRESENT',
        FUTURE = 'FUTURE',
        PRESENT_OR_FUTURE = 'PRESENT_OR_FUTURE',
    }
}

